module.exports = __webpack_public_path__ + "static/media/background-service.ed97d413.svg";